import { Button } from "flowbite-react"
import React from "react"
import { ReactComponent as ArrowIcon } from "../../images/arrow-3.svg"

const ArrowButtons = ({
  theme = "dark",
  nextDisabled,
  prevDisabled,
  nextClick = () => {},
  prevClick = () => {},
}) => {
  return (
    <div
      className={` flex gap-3 items-center  ${theme === "dark" ? "border-gray-600" : "border-white-200"} rounded-full`}
    >
      <Button
        className={`border bg-transparent z-10  ${
          theme === "dark"
            ? `border-black-100 ${prevDisabled ? "border-gray-400" : "hover:bg-blue-100 hover:border-none"}`
            : ` border-white-200 ${prevDisabled ? "border-gray-200" : "hover:bg-blue-100 hover:border-none"}`
        }   duration-300 ease-in-out  w-12 md:w-16 h-12 md:h-16  rounded-[50%]  `}
        outline
        onClick={prevClick}
        disabled={prevDisabled}
        color="custom-theme"
        theme={{
          color: {
            "custom-theme": "",
          },
          inner: {
            base: ` ${
              theme === "dark"
                ? `  ${prevDisabled ? "!text-gray-400" : "!text-black-200  hover:!text-white-200 "}`
                : `  ${prevDisabled ? "!text-gray-200" : " !text-white-200 hover:!text-white-200"}`
            }  !px-0 !py-0 flex items-center h-full text-[16px]  !bg-transparent`,
          },
        }}
      >
        <ArrowIcon className="box-content scale-75 md:scale-100 " />
      </Button>
      <Button
        className={`border bg-transparent z-10 rotate-180 ${
          theme === "dark"
            ? `border-black-100 ${nextDisabled ? "border-gray-400" : "hover:bg-blue-100 hover:border-none"}`
            : ` border-white-200 ${nextDisabled ? "border-gray-200" : "hover:bg-blue-100 hover:border-none"}`
        }   duration-300 ease-in-out  w-12 md:w-16 h-12 md:h-16  rounded-[50%]  `}
        outline
        onClick={nextClick}
        disabled={nextDisabled}
        color="custom-theme"
        theme={{
          color: {
            "custom-theme": "",
          },
          inner: {
            base: ` ${
              theme === "dark"
                ? `  ${nextDisabled ? "!text-gray-400" : "!text-black-200  hover:!text-white-200 "}`
                : `  ${nextDisabled ? "!text-gray-200" : " !text-white-200 hover:!text-white-200"}`
            }  !px-0 !py-0 flex items-center h-full text-[16px]  !bg-transparent`,
          },
        }}
      >
        <ArrowIcon className="box-content scale-75 md:scale-100 " />
      </Button>
    </div>
  )
}

export default ArrowButtons
